import { getAttributeData } from './brandingUtil';

const CUSTOM_BODY_SECTION_KEY = 'web.body.custom.section';
let customBodySectionStyleAdded = false;

const applyCustomCSS = (attributes) => {
    if (!customBodySectionStyleAdded) {
        const attributeData = getAttributeData(
            attributes || [],
            CUSTOM_BODY_SECTION_KEY,
        );

        if (attributeData && attributeData.value) {
            const style = document.createElement('style');
            style.appendChild(document.createTextNode(attributeData.value));
            document.body.appendChild(style);
            customBodySectionStyleAdded = true;
        }
    }
};

export default applyCustomCSS;
